import type { PurchaseMode } from "@/features/payment/shopPurchaseService";
import type { PlayerOwner } from "@/features/payment/types";

export type PurchaseGateDecision =
  | { readonly kind: "allow" }
  | { readonly kind: "recommend-sign-in" }
  | { readonly kind: "require-sign-in" };

export type PurchaseProductKind = "one-time" | "subscription";

export interface PurchaseGateConfig {
  readonly recommendSignInForAnonymous: boolean;
  readonly applyInDevFreeMode: boolean;
  readonly purchaseMode: PurchaseMode;
}

export interface PurchaseGateInput {
  readonly ownerKind: PlayerOwner["ownerKind"];
  readonly product: { readonly kind: PurchaseProductKind };
  readonly config: PurchaseGateConfig;
}

export function evaluatePurchaseGate(
  input: PurchaseGateInput,
): PurchaseGateDecision {
  const { ownerKind, product, config } = input;

  if (ownerKind === "signedIn") return { kind: "allow" };
  if (ownerKind === "local") return { kind: "allow" };

  if (product.kind === "subscription") {
    return { kind: "require-sign-in" };
  }

  if (config.purchaseMode === "dev_free" && !config.applyInDevFreeMode) {
    return { kind: "allow" };
  }

  if (config.recommendSignInForAnonymous) {
    return { kind: "recommend-sign-in" };
  }

  return { kind: "allow" };
}
